module.exports = __webpack_public_path__ + "img/logo.8898a7d3.svg";